module.exports = __webpack_public_path__ + "img/medical_medicine_analgesic2.80a3b97b.jpg";